import React from 'react';
import { FaTasks, FaUsers, FaMoneyBillWave } from 'react-icons/fa';

function OverviewTab({ event, tasks, rsvps, budget }) {
  const completedTasks = tasks.filter(t => t.status === 'completed').length;
  const totalExpenses = budget?.expenses?.reduce((sum, exp) => sum + exp.amount, 0) || 0;
  const totalContributions = budget?.contributions?.reduce((sum, cont) => sum + cont.amount, 0) || 0;

  return (
    <div className="space-y-6" data-testid="overview-tab">
      {/* Description */}
      {event?.description && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">About This Event</h3>
          <p className="text-gray-600">{event.description}</p>
        </div>
      )}

      {/* Stats */}
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-between mb-3">
            <FaTasks className="text-blue-600 text-2xl" />
            <span className="text-3xl font-bold text-gray-800">{completedTasks}/{tasks.length}</span>
          </div>
          <p className="text-gray-600">Tasks Completed</p>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-between mb-3">
            <FaUsers className="text-green-600 text-2xl" />
            <span className="text-3xl font-bold text-gray-800">{rsvps.filter(r => r.status === 'attending' || r.response === 'attending').length}</span>
          </div>
          <p className="text-gray-600">Attending</p>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-between mb-3">
            <FaMoneyBillWave className="text-yellow-600 text-2xl" />
            <span className="text-3xl font-bold text-gray-800">${totalContributions.toFixed(2)}</span>
          </div>
          <p className="text-gray-600">Contributions (of ${totalExpenses.toFixed(2)})</p>
        </div>
      </div>
    </div>
  );
}

export default OverviewTab;
